import { UntypedFormControl, ValidationErrors } from '@angular/forms';
import { get } from 'lodash';
import moment from 'moment';

const PHONE_NUMBER_REGEXP: RegExp = /^\+(?:[0-9][ ]?){6,14}[0-9]$/;
const WEB_ADDRESS_REGEXP: RegExp = /^http(s?):\/\/([^?#]*)(\?([^#]*))?(#(.*))?/;

export function PhoneValidator(control: UntypedFormControl): ValidationErrors {
  if (!control.value) {
    return null;
  }

  return PHONE_NUMBER_REGEXP.test(control.value) ? null : { phone: true };
}

export function WebAddressValidator(
  control: UntypedFormControl
): ValidationErrors {
  if (!control.value) {
    return null;
  }

  const RegExpInstance = new RegExp(WEB_ADDRESS_REGEXP);

  if (!RegExpInstance.test(control.value)) {
    return { webAddress: true };
  }

  return null;
}

export function futureDateTimeValidation(
  control: UntypedFormControl
): ValidationErrors {
  if (!control.value) {
    return null;
  }

  const controlDateTime = moment(control.value)
    .seconds(0)
    .milliseconds(0)
    .valueOf();
  const currentDateTime = moment().seconds(0).milliseconds(0).valueOf();

  if (controlDateTime > currentDateTime) {
    return { futureDateTime: true };
  }
  return null;
}

export function pastDateTimeValidation(
  control: UntypedFormControl
): ValidationErrors {
  if (!control.value) {
    return null;
  }

  const controlDateTime = moment(control.value)
    .seconds(0)
    .milliseconds(0)
    .valueOf();
  const currentDateTime = moment().seconds(0).milliseconds(0).valueOf();

  if (controlDateTime < currentDateTime) {
    return { pastDateTime: true };
  }
  return null;
}

export function futureDateValidation(
  control: UntypedFormControl
): ValidationErrors {
  if (!control.value) {
    return null;
  }

  const controlDate = moment(control.value)
    .hours(0)
    .minutes(0)
    .seconds(0)
    .milliseconds(0)
    .valueOf();
  const currentDate = moment()
    .hours(0)
    .minutes(0)
    .seconds(0)
    .milliseconds(0)
    .valueOf();

  if (controlDate > currentDate) {
    return { futureDate: true };
  }
  return null;
}

export function pastDateValidation(
  control: UntypedFormControl
): ValidationErrors {
  if (!control.value) {
    return null;
  }

  const controlDate = moment(control.value)
    .hours(0)
    .minutes(0)
    .seconds(0)
    .milliseconds(0)
    .valueOf();
  const currentDate = moment()
    .hours(0)
    .minutes(0)
    .seconds(0)
    .milliseconds(0)
    .valueOf();

  if (controlDate < currentDate) {
    return { pastDate: true };
  }
  return null;
}

export function maxValueError(err, field): string {
  const max = get(field, 'templateOptions.max', null);
  return max !== null
    ? `This value must not exceed ${max}.`
    : 'Value is not within allowed range.';
}

export function minValueError(err, field): string {
  const min = get(field, 'templateOptions.min', null);
  return min !== null
    ? `This value must not be lower than ${min}.`
    : 'Value is not within allowed range.';
}

export function maxLengthError(err, field): string {
  const max = get(field, 'templateOptions.maxLength', null);
  return max !== null
    ? `No more than ${max} characters are permitted.`
    : 'Value is not within allowed length.';
}

export function minLengthError(err, field): string {
  const min = get(field, 'templateOptions.minLength', null);
  return min !== null
    ? `At least ${min} character(s) are required .`
    : 'Value is not within allowed length.';
}
